import axios from 'axios';

export const settings = {
	state() {
		return {
			host: '',
			redirectUrl: '',

			redirectUrlAfterLogon: '',
			mifidUrl: '',
			myDataUrl: '',
			openNewAccountUrl: '',
			pitUrl: '',
			disableOpenNewClientAccount: false,
			loadingSettings: false,

			timeToLogout: window.S_TIME * 60 * 1000,

			errorCode: '',

			ErrorCodeEnum: {
				OtherError: 'OtherError',
			},
		};
	},
	mutations: {
		setHost(state, data) {
			state.host = data;
		},
		setRedirectUrl(state, data) {
			state.redirectUrl = data;
		},
		setRedirectUrlAfterLogon(state, data) {
			state.redirectUrlAfterLogon = data;
		},
		setMifidUrl(state, data) {
			state.mifidUrl = data;
		},
		setMyDataUrl(state, data) {
			state.myDataUrl = data;
		},
		setOpenNewAccountUrl(state, data) {
			state.openNewAccountUrl = data;
		},
		setPitUrl(state, data) {
			state.pitUrl = data;
		},
		setDisableOpenNewClientAccount(state, data) {
			state.disableOpenNewClientAccount = data;
		},
		setErrorCode(state, data) {
			state.errorCode = data;
		},
		setLoadingSettings(state, data) {
			state.loadingSettings = data;
		},
	},
	getters: {
		getHost: (state) => state.host,
		getRedirectUrl: (state) => state.redirectUrl,
		getRedirectUrlAfterLogon: (state) => state.redirectUrlAfterLogon,
		getMifidUrl: (state) => state.mifidUrl,
		getMyDataUrl: (state) => state.myDataUrl,
		getOpenNewAccountUrl: (state) => state.openNewAccountUrl,
		getPitUrl: (state) => state.pitUrl,
		getDisableOpenNewClientAccount: (state) =>
			state.disableOpenNewClientAccount,
		getLoadingSettings: (state) => {
			return state.loadingSettings;
		},
		getTimeToLogout: (state) => {
			return state.timeToLogout;
		},
		getErrorCode: (state) => {
			return state.errorCode;
		},
		getErrorCodeEnum: (state) => {
			return state.ErrorCodeEnum;
		},
	},

	actions: {
		fetchSettings({ commit }) {
			commit('setLoadingSettings', true);
			return axios
				.get('front-settings', {
					headers: {
						'User-Source': window.location.href,
					},
				})
				.then((response) => {
					const data = response.data;

					commit('setHost', data.host || '');
					commit('setRedirectUrl', data.redirectUrl || '');
				})
				.catch(() => {})
				.finally(() => {
					commit('setLoadingSettings', false);
				});
		},
		fetchInternalSettings({ commit }) {
			commit('setLoadingSettings', true);
			return axios
				.get('internal-settings', {
					headers: {
						'User-Source': window.location.href,
					},
				})
				.then((response) => {
					const data = response.data;

					commit(
						'setRedirectUrlAfterLogon',
						data.redirectUrlAfterLogon || '',
					);
					commit('setMifidUrl', data.mifidUrl || '');
					commit('setMyDataUrl', data.myDataUrl || '');
					commit(
						'setOpenNewAccountUrl',
						data.openNewAccountUrl || '',
					);
					commit('setPitUrl', data.pitUrl || '');
					commit(
						'setDisableOpenNewClientAccount',
						data.disableOpenNewClientAccount || false,
					);
				})
				.catch(() => {})
				.finally(() => {
					commit('setLoadingSettings', false);
				});
		},
	},
};
